const addedClass = [];

function addBodyClass(id, val) {
    if (document.documentElement.classList) {
        if (!addedClass.includes(id)) {
            document.documentElement.classList.add(`n-${val ? '' : 'no-'}${id}`);
            addedClass.push(id);
        }
    }
}

export function touchevents() {
    const check = 'ontouchstart' in window;

    addBodyClass('touchevents', check);

    return check;
}



/** WEBPACK FOOTER **
 ** ./assets/js/vendor/lite-browsercheck.js
 **/